
export default function Footer() {
  return (
    <footer className="bg-[#0B1F3A] py-12 sm:py-16 lg:py-20 px-4 sm:px-6">
      <div className="max-w-7xl mx-auto">
        {/* Main Footer Content */}
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-8 sm:gap-10 lg:gap-12 mb-10 sm:mb-12">
          {/* Brand Column */}
          <div className="col-span-2 sm:col-span-2 md:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://static.readdy.ai/image/ec7d44241e5d5731ab0de78142a46920/55979cdc92171d0792a109e88caba25d.png"
                alt="Premier Renovations Logo"
                className="h-14 w-auto"
              />
            </div>
            <h3
              className="text-white text-lg sm:text-xl font-bold mb-2"
              style={{ fontFamily: "Montserrat, sans-serif" }}
            >
              Premier Renovations
            </h3>
            <p
              className="text-white/60 text-sm mb-4"
              style={{ fontFamily: "Open Sans, sans-serif" }}
            >
              Affordable Kitchen and Bath Solutions
            </p>
            <p
              className="text-white/70 text-sm leading-relaxed"
              style={{
                fontFamily: "Open Sans, sans-serif",
                lineHeight: "1.6",
              }}
            >
              Transforming homes with expert craftsmanship in kitchen and
              bathroom remodeling.
            </p>
          </div>

          {/* Services Column */}
          <div>
            <h4
              className="text-white text-xs font-semibold tracking-widest uppercase mb-4 sm:mb-6"
              style={{ fontFamily: "Open Sans, sans-serif" }}
            >
              Services
            </h4>
            <ul className="space-y-3 sm:space-y-4">
              <li>
                <a
                  href="#services"
                  className="text-white/70 hover:text-white transition-colors text-sm cursor-pointer"
                  style={{ fontFamily: "Open Sans, sans-serif" }}
                >
                  Kitchen Remodeling
                </a>
              </li>
              <li>
                <a
                  href="#services"
                  className="text-white/70 hover:text-white transition-colors text-sm cursor-pointer"
                  style={{ fontFamily: "Open Sans, sans-serif" }}
                >
                  Bathroom Remodels
                </a>
              </li>
              <li>
                <a
                  href="#services"
                  className="text-white/70 hover:text-white transition-colors text-sm cursor-pointer"
                  style={{ fontFamily: "Open Sans, sans-serif" }}
                >
                  Walk-In Tubs
                </a>
              </li>
              <li>
                <a
                  href="#services"
                  className="text-white/70 hover:text-white transition-colors text-sm cursor-pointer"
                  style={{ fontFamily: "Open Sans, sans-serif" }}
                >
                  Bathroom Renovations
                </a>
              </li>
            </ul>
          </div>

          {/* Company Column */}
          <div>
            <h4
              className="text-white text-xs font-semibold tracking-widest uppercase mb-4 sm:mb-6"
              style={{ fontFamily: "Open Sans, sans-serif" }}
            >
              Company
            </h4>
            <ul className="space-y-3 sm:space-y-4">
              <li>
                <a
                  href="#about"
                  className="text-white/70 hover:text-white transition-colors text-sm cursor-pointer"
                  style={{ fontFamily: "Open Sans, sans-serif" }}
                >
                  About Us
                </a>
              </li>
              <li>
                <a
                  href="#services"
                  className="text-white/70 hover:text-white transition-colors text-sm cursor-pointer"
                  style={{ fontFamily: "Open Sans, sans-serif" }}
                >
                  Our Work
                </a>
              </li>
              <li>
                <a
                  href="#contact"
                  className="text-white/70 hover:text-white transition-colors text-sm cursor-pointer"
                  style={{ fontFamily: "Open Sans, sans-serif" }}
                >
                  Contact
                </a>
              </li>
              <li>
                <a
                  href="#contact"
                  className="text-white/70 hover:text-white transition-colors text-sm cursor-pointer"
                  style={{ fontFamily: "Open Sans, sans-serif" }}
                >
                  Free Estimate
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Column */}
          <div className="col-span-2 sm:col-span-1">
            <h4
              className="text-white text-xs font-semibold tracking-widest uppercase mb-4 sm:mb-6"
              style={{ fontFamily: "Open Sans, sans-serif" }}
            >
              Contact
            </h4>
            <ul className="space-y-3 sm:space-y-4">
              <li>
                <a
                  href="tel:316-867-6848"
                  className="text-white/70 hover:text-white transition-colors text-sm cursor-pointer"
                  style={{ fontFamily: "Open Sans, sans-serif" }}
                >
                  316-867-6848
                </a>
              </li>
              <li>
                <a
                  href="mailto:info@premier-ict.com"
                  className="text-white/70 hover:text-white transition-colors text-sm cursor-pointer break-all"
                  style={{ fontFamily: "Open Sans, sans-serif" }}
                >
                  info@premier-ict.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/15 pt-6 sm:pt-8">
          <p
            className="text-white/60 text-xs sm:text-sm text-center"
            style={{ fontFamily: "Open Sans, sans-serif" }}
          >
            © 2025 Premier Renovations. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
